import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { SEOHelmet } from '../../hooks/useSEO';

import { FaAngleDoubleRight } from "react-icons/fa";
// import rabbit from "../../assets/blogpages/2x/Asset 84@2x.png";
import Liona from "../../assets/blogpages/2x/Asset 108@2x.png";
import dog from "../../assets/blogpages/2x/Asset 109@2x.png";
// import activity1 from "../../assets/blogpages/2x/Asset 34@2x.png";
import activity1 from "../../assets/blogpages/2x/Asset 106@2x.png"
// import activity2 from "../../assets/blogpages/2x/Asset 91@2x.png";
import activity2 from "../../assets/blogpages/2x/Asset 107@2x.png"
import finalElephant from "../../assets/blogpages/2x/Asset 71@2x.png";
import safiaElephant from "../../assets/blogpages/2x/Asset 73@2x.png";
import { Link, useParams, useNavigate } from "react-router-dom";

import TheChallenge from "../../assets/blogpages/2x/Asset 97@2x.png";
import Whattodo from "../../assets/blogpages/2x/Asset 95@2x.png";
import Whatnottodo from "../../assets/blogpages/2x/Asset 93@2x.png";
import activitycard from "../../assets/blogpages/2x/Asset 94@2x.png";
import whatchlearn from "../../assets/blogpages/2x/Asset 96@2x.png";
import board from "../../assets/blogpages/2x/Asset 90@2x.png";

import weeklyActivity2 from "../../assets/blogpages/2x/Asset 39@2x.png";


import Linkdin from "../../assets/blogpages/2x/Asset 70@2x.png";
import youtube from "../../assets/blogpages/2x/Asset 80@2x.png";
import facebook from "../../assets/blogpages/2x/Asset 81@2x.png";
import instaIcon from "../../assets/blogpages/2x/Asset 69@2x.png";
import Pinterest from "../../assets/blogpages/2x/Asset 83@2x.png";
import share from "../../assets/blogpages/2x/Asset 78@2x.png";
import thumbnail from "../../assets/blogs/2x/Blog 3 Set 9.png";
import bell from "../../assets/blogpages/2x/Asset 75@2x.png";
import weeklyActivity from "../../assets/blogpages/2x/Asset 74@2x.png";
import kidsStory from "../../assets/blogpages/Story/set 09.png";
import kidsSong from "../../assets/blogpages/Jingle/set 09.png";
import kidslearning from "../../assets/blogpages/Interactive/Set 09.png";

import thumbnail1 from "../../assets/blogs/2x/Blog 4 Set 8.png";
import thumbnail2 from "../../assets/blogs/2x/Blog 5 Set 1.png";
import thumbnail3 from "../../assets/blogpages/2x/Asset 99@2x.png";

import boardimg from "../../assets/blogs/2x/Asset 25@2x.png";
import elephantImg from "../../assets/blogs/2x/Asset 22@2x.png";
import cowImg from "../../assets/blogs/2x/Asset 31@2x.png";
import lionImg from "../../assets/blogs/2x/Asset 29@2x.png";
import deerImg from "../../assets/blogs/2x/Asset 30@2x.png";
import turtleImg from "../../assets/blogs/2x/Asset 28@2x.png";
import elephiImg from "../../assets/blogs/2x/Asset 32@2x.png";
import geassdivImg from "../../assets/blogs/2x/Asset 23@2x.png";
import blog1Img from "../../assets/blogs/2x/Asset 24@2x.png";
import styles from "./JungleMoralsUI.module.css"
import { Helmet } from "react-helmet-async";





const HowtoTeachKidsThatParentsKnowBest = () => {

    const { slug } = useParams(); // ✅ slug receive karo
    const navigate = useNavigate();

    // ✅ Blog data ko slug se match karo (optional - agar dynamic content chahiye)
    const blogData = {
        "how-to-teach-kids-that-parents-know-best": {
            title: "How to Teach Kids That Parents Know Best",
            date: "03 January 2026",
            readTime: "5 min read"
        },
    };

    const currentBlog = blogData[slug] || {
        title: "Blog Not Found",
        date: "",
        readTime: ""
    };

 const handleBlogClick = (slug) => {
    navigate(`/blog/${slug}`);
  };


    const blogPost = [
        {
            id: 1,
            title: "Kids Story",
            animal: "elephant",
            animalImg: elephantImg,
            image: kidsStory,
            youtubeLink: "https://youtu.be/zkw1VFEqqWA?si=APU3dwH8JGr0GLd1" // Apna link yahan daalo
        },
        {
            id: 2,
            title: "Kids Song",
            animal: "cow",
            animalImg: cowImg,
            image: kidsSong,
            youtubeLink: "https://www.youtube.com/watch?v=q8ck8D7VPso"
        },
        {
            id: 3,
            title: "Kids Learning",
            animal: "lion",
            animalImg: lionImg,
            image: kidslearning,
            youtubeLink: "https://youtu.be/0ESyLc89DHg?si=LVBR6RW_iI0icDc6"
        },
    ];


    const blogPosts = [

        {
            id: 1,
            title: "How to Teach Kids Do's and Don'ts for...",
            description: "As children grow between ages 3-7, they begin exploring the world with curiosity and confidence. This is an exciting stage...",
            date: "10 January 2026",
            readTime: "4 min read",
            animal: "deer", // brown deer
            animalImg: deerImg, // Yahan image add karein
             slug: "how-to-teach-kids-do-s-and-don-ts-for-safety-and-kindness",
            image: thumbnail1,
            
        },
        {
            id: 2,
            title: "How to Teach Kids About Stranger Safety:",
            description: "As children grow between ages 3-7, they become more curious about the world around them. They begin exploring...",
            date: "17 January 2026",
            readTime: "4 min read",
            animal: "turtle", // green turtle
            animalImg: turtleImg, // Yahan image add karein
            image: thumbnail2,
             slug: "how-to-teach-kids-about-stranger-safety",
           
        },
        {
            id: 3,
            title: "Teach Kids to Be On Time",
            description: "Teaching kids to be on time is one of the most practical life skills yet one of the hardest for young children to understand...",
            date: "20 December 2025",
            readTime: "6 min read",
            animal: "elephant2", // gray elephant
            animalImg: elephiImg, // Yahan image add karein
            image: thumbnail3,
             slug: "how-to-teach-kids-to-be-on-time",
        
        }
    ];

    const animalStyles = {
        elephant: { top: '-50px', left: '-80px', transform: 'scale(0.8)' },
        cow: { top: '-75px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        lion: { top: '-80px', right: '-60px', transform: 'scale(0.8)' },
        deer: { top: '-85px', left: '-85px', transform: 'scale(0.75)' },
        turtle: { top: '-80px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        elephant2: { top: '-70px', right: '-80px', transform: 'scale(0.8)' }
    };

    //share blogs function
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    // text: 'Is blog ko dekho ',
                    url: window.location.href,
                });
            } catch (err) {
                // user ne cancel kiya to kuch mat karo
            }
        } else {
            alert('Share supported nahi hai is browser me');
        }
    };



    const socialLinks = [
        { img: Linkdin, link: "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true" },
        { img: youtube, link: "https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA" },
        { img: facebook, link: "https://www.facebook.com/junglemorals/" },
        { img: instaIcon, link: "https://www.instagram.com/junglemorals/" },
        { img: Pinterest, link: "https://in.pinterest.com/junglemorals/" },
        { img: share, isShare: true },
    ];

    const TopCard = ({ title, img, onClick }) => (
        <div className="col-4 col-sm-4 col-md-4 col-lg">
            <div
                onClick={onClick}
                className="position-relative overflow-hidden"
                style={{ cursor: "pointer" }}
            >
                {/* Background image */}
                <img src={img} alt={title} className="img-fluid w-100" />

                {/* Overlay text */}
                <div
                    className={`position-absolute top-50 start-50 translate-middle fw-bold ${styles.usereff}`}

                >
                    {title}
                </div>
            </div>
        </div>
    );


    const challengeRef = useRef(null);
    const whatToDoRef = useRef(null);
    const whatNotRef = useRef(null);
    const activityRef = useRef(null);
    const watchRef = useRef(null);
    const newsletterRef = useRef(null);


    const scrollTo = (ref) => {
        ref.current.scrollIntoView({ behavior: "smooth" });
    };

    //for the margintop fix of page
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 585);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 585);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    //SEO meta information


    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     // Fetch blogs from localStorage (same as admin dashboard)
    //     const blogs = JSON.parse(localStorage.getItem("adminBlogs"));

    //     if (blogs) {
    //         const currentBlog = blogs.find(b => b.slug === slug);
    //         setBlog(currentBlog);
    //     }

    //     setLoading(false);
    // }, [slug]);

    // if (loading) {
    //     return <div className="container py-5 text-center">Loading...</div>;
    // }

    // if (!blog) {
    //     return (
    //         <div className="container py-5">
    //             <div className="alert alert-danger">
    //                 <h4>Blog not found</h4>
    //                 <p>Sorry, the blog post you're looking for doesn't exist.</p>
    //             </div>
    //         </div>
    //     );
    // }


    return (

        <>
             <Helmet>
  <title>
    Why Kids Should Listen to Parents | Jungle Morals
  </title>

  <meta
    name="description"
    content="Help kids aged 3-7 trust parental guidance without power struggles. Learn gentle parenting tips that build listening, emotional connection, and cooperation."
  />

  <meta
    name="robots"
    content="index, follow"
  />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/blog/how-to-teach-kids-that-parents-know-best"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Why Kids Should Listen to Parents | Jungle Morals"
  />

  <meta
    property="og:description"
    content="Gentle parenting strategies to help children trust guidance, improve listening, and build emotional connection without fear or pressure."
  />

  <meta
    property="og:url"
    content="https://www.junglemorals.com/blog/how-to-teach-kids-that-parents-know-best"
  />

  <meta
    property="og:type"
    content="article"
  />

  <meta
    property="og:image"
    content="https://www.junglemorals.com/static/media/Blog%203%20Set%209.8faa92c1ed0af6c63fb1.png"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Why Kids Should Listen to Parents | Jungle Morals"
  />

  <meta
    name="twitter:description"
    content="Gentle parenting strategies to help children trust guidance, improve listening, and build emotional connection without fear or pressure."
  />

  <meta
    name="twitter:image"
    content="https://www.junglemorals.com/static/media/Blog%203%20Set%209.8faa92c1ed0af6c63fb1.png"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/logo.webp"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id":
            "https://www.junglemorals.com/blog/how-to-teach-kids-that-parents-know-best#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blogs",
              item: "https://www.junglemorals.com/blogs"
            },
            {
              "@type": "ListItem",
              position: 3,
              name:
                "How to Teach Kids That Parents Know Best",
              item:
                "https://www.junglemorals.com/blog/how-to-teach-kids-that-parents-know-best"
            }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id":
            "https://www.junglemorals.com/blog/how-to-teach-kids-that-parents-know-best#article",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id":
              "https://www.junglemorals.com/blog/how-to-teach-kids-that-parents-know-best"
          },
          headline:
            "How to Teach Kids That Parents Know Best",
          description:
            "A gentle parenting guide that helps children ages 3-7 build trust, emotional connection, and healthy listening habits through calm communication and empathy.",
          image: [
            "https://www.junglemorals.com/static/media/Blog%203%20Set%209.8faa92c1ed0af6c63fb1.png"
          ],
          author: {
            "@type": "Organization",
            name: "Jungle Morals"
          },
          publisher: {
            "@id":
              "https://www.junglemorals.com/#organization"
          },
          datePublished: "2026-01-03",
          inLanguage: "en"
        }
      ]
    })}
  </script>
</Helmet>
            <div className="" style={{
                color: '#005d52',
                marginTop: isMobile ? '-62vh' : '-45vh',
                minHeight: '100vh',
                position: 'relative',
                overflow: 'hidden',

            }}>
                <div className="container py-3 py-md-2 col-md-10 text-start" style={{ maxWidth: '1300px' }}
                >

                    {/* Breadcrumb Path */}
                    <div className={`path fs-4 ${styles.Breadcrumb} p-2 m-0 ps-0 mb-3 mb-md-2 d-flex flex-wrap align-items-center gap-2 font-brandon z-2`}>
                        <Link to={'/'} className="text-decoration-none text-reset pe-auto z-1">
                            <span className="path-element text-pr-black ff-roboto pe-auto">Home</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <Link to={'/blogs'} className="text-decoration-none text-reset z-1">
                            <span className="path-element text-pr-black ff-roboto">Blogs</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <span className="path-element">How to Teach Kids That Parents Know Best</span>
                    </div>
                    {/* Main Heading */}
                    <h1 className={`font-brandon-black  display-1 fw-bold ${styles.mainh1} `} >
                       How to Teach Kids That Parents Know Best
                    </h1>

                    {/* Subheading */}
                    <p className={`font-brandon-thin-italic ${styles.tagline} lh-sm fst-italic`}>
                        Simple conversations, activities, and a kids moral story that help children learn trust, safety, and emotional security.
                    </p>

                    {/* Social Links & Date Section */}
                    <div className="path m-0 ps-0  mb-md-2 d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 gap-sm-2">

                        {/* Social Icons */}
                        <div className="path-element text-muted ff-roboto d-flex align-items-center gap-3 order-2 order-sm-1">
                            {socialLinks.map((item, index) => (
                                <a
                                    key={index}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img
                                        src={item.img}
                                        alt="social-icon"
                                        width="40"
                                        height="40"
                                        className="social-icon"
                                        style={{ objectFit: "contain", cursor: "pointer" }}
                                        onClick={() => {
                                            if (item.isShare) {
                                                handleShare();        // ✅ native share
                                            } else {
                                                window.open(item.link, '_blank'); // ✅ normal social links
                                            }
                                        }}

                                    />
                                </a>
                            ))}
                        </div>

                        {/* Date & Read Time */}
                        <div className="d-flex flex-row flex-sm-column align-items-start align-items-sm-end gap-2 gap-sm-1 order-1 order-sm-2 font-brandon">
                            <small className={`text-nowrap ${styles.date}`} style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                03 January 2026
                            </small>
                            <span className="d-inline d-sm-none text-muted">•</span>
                            <small className={`text-nowrap ${styles.date}`} style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                5 min read
                            </small>
                        </div>
                    </div>
                </div>



                <div className="container-fluid px-3 px-md-4" style={{ maxWidth: '1600px' }}
                >
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-10">
                            <div className={`row text-center g-2 g-md-3 font-brandon-bold  ${styles.strongtext}`}>
                                <TopCard title="The Challenge" img={TheChallenge} onClick={() => scrollTo(challengeRef)} />
                                <TopCard title="What To Do" img={Whattodo} onClick={() => scrollTo(whatToDoRef)} />
                                <TopCard title="What NOT To Do" img={Whatnottodo} onClick={() => scrollTo(whatNotRef)} />
                                <TopCard title="Activity Card" img={activitycard} onClick={() => scrollTo(activityRef)} />
                                <TopCard title="Watch and Learn" img={whatchlearn} onClick={() => scrollTo(watchRef)} />
                            </div>
                        </div>
                    </div>
                </div>


                <section ref={challengeRef} className="container  col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <div className="d-flex justify-content-center align-items-center flex-column">


                        <div
                            className="text-center board-wrapper"
                            style={{
                                backgroundImage: `url(${boardimg})`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                aspectRatio: '16 / 10',     // ⭐ key fix
                            }}
                        >
                            <img
                                src={thumbnail}
                                alt="Kids learning to trust parents, stay safe, and feel emotionally secure"
                                style={{
                                    width: '93%',
                                    height: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>

                        <div className="">
                            <h2 className={`font-brandon-black mt-2 mt-md-0 ${styles.strongtextheading} `}>Introduction</h2>
                            <p className={`font-brandon ${styles.introtext} lh-sm mb-5`}>As children grow between ages <strong className={styles.strongtext}> 3-7</strong>, they begin to explore independence and make more choices on their own. This is a healthy part of development. At the same time, many parents wonder how to explain why listening to parents is important, without sounding controlling or dismissive.</p>

                            <p className={`font-brandon ${styles.introtext} lh-sm mb-5`}>Parents often search for gentle parenting tips that explain  <strong className={styles.strongtext}>why parents know best for kids</strong>, while still respecting a child’s feelings and need for independence. Children need to feel emotionally safe, heard, and understood before they can build trust in parental guidance.</p>


                            <p className={`font-brandon ${styles.introtext} lh-sm`}>This week at Jungle Morals, we help children understand that <strong className={styles.strongtext}> parents know best not because they want control, but because they care deeply about safety, well-being, and happiness</strong>.</p>
                        </div>

                    </div>
                </section>


                <section ref={challengeRef} className={`container py-0 py-md-4 col-md-10 mt-3 ${styles.TheChallenge}`}
                >
                    <h2 className={`font-brandon-black   ${styles.strongtextheading} `} >The Challenge</h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 mb-md-5 fst-italic`}>Why children struggle to trust parental guidance</p>
                    <p className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 mb-md-5`}>Children do not resist listening because they are being disobedient. </p>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6">


                            <h3 className={`font-brandon-black  ${styles.strongtext2} `}> Very often, they are:</h3>
                            <ul className={`font-brandon ${styles.ul21} lh-sm  ps-4.5 mb-md-5`}>
                                <li>Testing independence</li>
                                <li>Learning decision-making</li>
                                <li>Reacting emotionally in the moment</li>
                                <li>Feeling frustrated by limits</li>
                                <li>Trying to understand fairness</li>
                            </ul>

                            <h3 className={`font-brandon-black  ${styles.strongtext2} `}>You may hear children say:</h3>
                            <ul  className={`font-brandon ${styles.ul21} lh-sm  ps-4.5 mb-md-5`} >
                                <li>“I know what I’m doing.”</li>
                                <li>“Why do I have to listen?”</li>
                                <li>“That’s not fair.”</li>
                                <li>“I can do it myself.”</li>
                            </ul>


                        </div>

                        <div className="col-md-6 text-center">
                            <img src={Liona} className={`${styles.Liona} img-fluid`} style={{marginTop:"-4rem"}} alt="cute lion cartoon character mascot with red cape for kids animation" width={"350"} />
                        </div>
                        <p className={`font-brandon ${styles.introtext}  lh-sm mb-5`}>Behind these words are big feelings such as curiosity, frustration, and a growing desire for autonomy. Learning that<strong className={styles.strongtext}> parents know best for kids</strong> takes time, reassurance, and emotional connection.</p>

                    </div>
                </section>



                <section ref={whatToDoRef} className="container col-md-10 py-1" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black  mb-3 ${styles.strongtextheading}`}>What To Do: Gentle Parenting Tips to Help Kids Trust Parents</h2>
                    <p className={`font-brandon ${styles.TheChallengeh2} ${styles.fs2} lh-sm fst-italic`}>Here are calm and effective ways to build trust without power struggles:</p>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6">

                            <h5 className={`font-brandon-bold mt-3 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Explain the reason behind rules</h5>
                            <ul  className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Children are more willing to cooperate when they understand the purpose.</li>
                                <li>Say, “I’m asking you to do this to keep you safe.”</li>
                            </ul>

                            <h5 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Acknowledge feelings before correcting</h5>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Let children feel heard first.</li>
                                <li>“I know you’re upset. That makes sense.”</li>
                            </ul>

                            <h5 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Offer limited choices</h5>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Choices help children feel independent within safe boundaries.</li>
                                <li>“You can choose this or that.”</li>
                            </ul>

                            <h5 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Stay calm and consistent</h5>
                            <ul className={`font-brandon ${styles.fs2} ${styles.li_WTD3} mt-2 lh-sm  list-unstyled ps-0`}>
                                <li>Consistency helps children feel secure and builds long-term trust.</li>
                            </ul>

                            <h5 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Model listening and respect</h5>
                            <ul className={`font-brandon ${styles.fs2} ${styles.li_WTD3} mt-2 lh-sm  list-unstyled ps-0`}>
                                <li>Children learn trust when they experience it themselves.</li>
                            </ul>

                        </div>
                        <div className="col-md-6 text-center">
                            <img src={dog}  className={`${styles.imgfluid1} img-fluid`} alt="cartoon dog carrying puppy on back with worm in mouth jungle moral story character" width={"440"} />
                        </div>
                    </div>
                </section>


                <section ref={whatNotRef} className="container col-md-10 py-1 mt-5" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black mb-2 ${styles.strongtextheading}`}>What NOT To Do</h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 fst-italic`}>When teaching children why listening to parents is important, avoid these approaches.</p>
                    <div className=" col-md-12">
                         <h3 className={`font-brandon-bold ${styles.fs2} ${styles.strongtext} `}>Avoid:</h3>
                        <ul className={`font-brandon ${styles.fs2} ${styles.avoidtext} lh-sm  list-unstyled ps-0`}>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not dismiss feelings</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                Do not rely on “because I said so”</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                               Do not threaten or scare</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not shame or compare</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not expect instant obedience</li>

                        </ul>
                        <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2}  lh-sm mt-4 mt-md-5`}>Trust grows through connection, not authority.</p>
                        <p className={`font-brandon ${styles.fs2} ${styles.belltext} lh-sm mt-4 mt-md-5`}>
                                     <img
                          src={bell}
                          alt="Yellow notification bell icon flat design"
                          width="50px"
                          className="mb-2 me-3"
                        />
                                      Want weekly Jungle activities, updates, and more?{" "}
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                        
                                          if (newsletterRef.current) {
                                            newsletterRef.current.scrollIntoView({
                                              behavior: "smooth",
                                              block: "center",
                                            });
                                          }
                                        }}
                                      >
                                        {" "}
                                        Join Our Newsletter!
                                      </Link>
                                    </p>
                    </div>
                </section>


                <section ref={activityRef} className="container py-1 col-md-10 " style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black  ${styles.strongtextheading}`}>“Remembering Love” Activity Card: </h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm fst-italic`}>Helping Kids Understand Parental Guidance</p>

                    <div className="row my-4">
                        <div className="col-md-6">
                            <img src={activity1}  alt="parents are the best activity card for kids with elephant and lion jungle morals characters" className="img-fluid " />
                        </div>
                        <div className="col-md-6">
                            <img src={activity2}  alt="kids activity about appreciating parents efforts and sharing childhood stories jungle morals worksheet" className="img-fluid " />
                        </div>
                    </div>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm fst-italic`} >Why this activity works:
This activity helps children see how parents make decisions with care and responsibility. It encourages reflection and discussion instead of blind obedience.</p>

                </section>


                <section ref={watchRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-bold ${styles.strongtext}`}>How parents should guide it</h2>
                    <ul className={`font-brandon ${styles.fs2} lh-sm ${styles.activityULLI}  ps-0.5`}>
                        <li>Sit with your child and read each situation together</li>
                        <li>Ask what choice they would make</li>
                        <li>Gently explain how parents think about safety and care</li>
                    </ul>


                    <h2 className={`font-brandon-bold ${styles.strongtext}`}>What children learn:</h2>
                    <ul className={`font-brandon ${styles.fs2} lh-sm ${styles.activityULLI}  ps-0.5`}>
                        <li>Trust</li>
                        <li>Emotional security</li>
                        <li>Respect</li>
                        <li>Decision-making</li>
                        <li>Understanding guidance</li>
                    </ul>




                    <div>

                        <div className="position-relative d-flex justify-content-center align-items-center my-4">
                                      <Link
                                        to={"/form"}
                                        className="position-relative d-flex justify-content-center align-items-center my-4 text-reset"
                                      >
                                        <h3 className={`position-absolute ${styles.fs22} grab-text text-center font-adventuring`}>
                                          Grab your free activity card
                                        </h3>
                        
                                        {/* Board image */}
                                        <img
                                          src={board}
                                          alt="Colorful festive marquee light frame with glowing multicolor bulbs and blank banner space"
                                          className="img-fluid board-img"
                                          width={"800px"}
                                        />
                                      </Link>
                                    </div>


                        <h2 className={`font-brandon-bold   ${styles.strongtextheading}`}>Watch This Week’s - Parents Are the Best</h2>
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                        <div className={`row ${styles.Links} g-2 g-md-5`}>
                            {blogPost.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                    <div
                                        className="card h-100"
                                        style={{
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s ease'
                                        }}
                                        onClick={() => window.open(post.youtubeLink, '_blank')}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",
                                            height: "30vw",
                                            maxHeight: "100px",
                                            marginTop: "24%",
                                            position: 'absolute',
                                            marginLeft: "61%",
                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="Green leafy corner border nature decorative frame plant illustration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <h5 className="card-title font-brandon-bold fs-3 lh-sm" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px',
                                                textAlign: "center"
                                            }}>
                                                {post.title}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>

                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm mb-1 mt-4 mt-md-5`}>This animated kids moral story teaches:</p>
                    <ul className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-sm   ps-0.5`} >
                        <li>Trusting parents</li>
                        <li>Listening with understanding</li>
                        <li>Emotional safety</li>
                        <li>Learning that guidance comes from care</li>
                    </ul>
                    <p  className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-sm mb-4 mt-0 mb-md-5 mt-md-5`}>Kids love watching characters make small choices that lead to big learnings.</p>
                    <p className={`font-brandon ${styles.fs30} lh-sm d-flex gap-3`}>
                                <img
                                  src={bell}
                                  alt="Yellow notification bell icon flat design"
                                  srcset=""
                                  width={"50px"}
                                  className="mb-2  "
                                />
                                <Link
                                  to={"https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA"}
                                  target="blank"
                                >
                                  Watch more Jungle Morals stories on YouTube!
                                </Link>
                              </p>

                    <h4 className={`font-brandon-bold mt-0  mt-md-5  ${styles.strongtextheading}`}>Final Thoughts & Learnings</h4>
                    <ul className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-base   ps-0.5`}>
                        <li>Children learn punctuality through habits, not pressure</li>
                        <li>Time awareness develops slowly between ages three to seven</li>
                        <li>Visual routines help children understand daily time flow</li>
                        <li>Gentle reminders work better than rushing or scolding</li>
                        <li>Preparation reduces morning stress and last-minute delays</li>
                        <li>Praising e ort builds responsibility and self-confidence</li>
                        <li>Play-based activities make time management easier to learn</li>
                        <li>Consistency turns small routines into lifelong punctual habits</li>
                    </ul>

                </section>


                <section className={styles.wisdomSection} style={{ maxWidth: '2900px' }}
                >
                    <div className="container-fluid px-0" style={{ maxWidth: '1600px' }} >
                        <div className="row align-items-center justify-content-start mx-0">
                            <div className={`col-auto text-center ${styles.elephantCol}`}>
                                <img
                                    src={finalElephant}
                                    className={`img-fluid ${styles.elephantImage}`}
                                    alt="elephant"
                                    style={{ marginTop: '-200px' }}   
                                />
                            </div>
                            <div className="col text-start text-white ps-0 ps-sm-3 ps-md-4 ps-lg-2 mb-md-5 ">
                                <h4 className={`font-brandon-black  mb-1 ${styles.wisdomTitle}`}>Final Jungle Wisdom</h4>
                                <p className={`font-brandon  lh-sm mb-1 ${styles.wisdomText}`}>
                                   When children feel safe and understood, trusting parents comes naturally.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>




                <section
                         className="container py-4 py-md-5 col-md-10 text-start d-flex justify-content-evenly flex-column"
                         style={{ maxWidth: "1300px" }}
                       >
                         <h3 className={`font-brandon-black mt-3 mb-3 ${styles.strongtextheading}`}>
                           Get Weekly Jungle Activities, Updates and More!
                         </h3>
                         <p className={`font-brandon ${styles.fs3} fst-italic lh-sm`}>
                           Want to build these habits at home? Subscribe to our newsletter and
                           download the free activity card.
                         </p>
               
                         <div
                           className="d-flex justify-content-center px-2"
                           ref={newsletterRef}
                         >
                           {/* Board Wrapper */}
                           <div
                             style={{
                               position: "relative",
                               width: "100%",
                               maxWidth: "700px", //  desktop same, mobile shrink
                             }}
                           >
                             {/* Board Image */}
                               <img
                               className={`${styles.mobIMG}`}
                               src={weeklyActivity2}
                               alt="Wooden frame border with green leaves decorative nature background blank template"
                               style={{
                                 width: "100%",
                                 height: "auto",
                                 // display: "none",
               
                               }}
                             />
                             <img
                             className={`${styles.desIMG}`}
                               src={weeklyActivity}
                               alt="Wooden frame border with green leaves decorative nature background blank template"
                               style={{
                                 width: "100%",
                                 height: "auto",
                                 // display: "none",
               
                               }}
                             />
               
                             {/* CONTENT INSIDE BOARD */}
                             <div
                             className={`${styles.mailbox}`}
                               style={{
                                 position: "absolute",
                                 top: "55%",
                                 left: "50%",
                                 transform: "translate(-50%, -50%)",
                                 width: "78%",
                                 textAlign: "center",
                               }}
                             >
                               {/* Email Input */}
                               <input
                                 type="email"
                                 className={`form-control ${styles.inputbox}  mb-2 font-brandon`}
                                 placeholder="Email ID"
                                 style={{
                                   borderRadius: "5px",
                                   border: "2px solid #9ec9bb",
                                   padding: "clamp(12px, 10vw, 6px) 18px",
                                   fontSize: "clamp(22px, 3vw, 5px)",
                                 }}
                               />
               
                               {/* Checkbox */}
                               <div className={`form-check ${styles.input2} d-flex justify-content-center align-items-center`}>
                                 <input
                                   className={`form-check-input ${styles.checkbox} me-3`}
                                   type="checkbox"
                                   id="weeklyCheck"
                                   style={{
                                     border: "1px solid #2f6f62",
                                     transform: "scale(1.5)",
                                   }}
                                 />
                                 <label
                                   className={`form-check-label ${styles.CTA} font-brandon fs-2 lh-sm`}
                                   htmlFor="weeklyCheck"
                                   style={{
                                     color: "#2f6f62",
                                     fontSize: "clamp(14px, 3vw, 14px)",
                                     marginBottom: "-4px",
                                   }}
                                 >
                                   Send Me Weekly Activities!
                                 </label>
                               </div>
               
                               {/* Small text */}
                               <p
                                 className={`text-reset font-brandon ${styles.CTA} fs-5 mb-0 mb-md-2 lh-sm`}
                                 style={{
                                   fontSize: "clamp(10px, 1.5vw, 12px)",
                                   marginBottom: "2px",
                                 }}
                               >
                                 We never spam. Unsubscribe anytime.
                               </p>
               
                               {/* Disclaimer */}
                               <p
                                 className={`text-reset fs-6 ${styles.CTA} ${styles.lastmailtext} font-brandon`}
                                 style={{
                                   fontSize: "clamp(9px, 2.2vw, 10px)",
                                   lineHeight: "1.3",
                                 }}
                               >
                                 By sharing your email address, you agree to receive marketing
                                 emails and consent to our{" "}
                                 <span className="text-decoration-underline">
                                   Terms and Conditions
                                 </span>{" "}
                                 and{" "}
                                 <span className="text-decoration-underline">
                                   Privacy Policy
                                 </span>
                                 .
                               </p>
                             </div>
                           </div>
                         </div>
               
                         {/* <div className="row align-items-center justify-content-center col-md-10">
                           <div className="col-md-4 text-center">
                             <img
                               src={safiaElephant}
                               alt="Cute blue cartoon elephant wearing yellow floral dress with purple garland and flower crown inside green circular frame vector illustration"
                               width="320"
                             />
                           </div>
               
                           <div className="col-md-8 text-start">
                             <h2 className={`mt-3 font-brandon ${styles.fs4}  fw-bold`}>
                               Safia Bano
                             </h2>
                             <p className={`font-brandon ${styles.fs3} lh-sm`}>
                               As the author, I am proud to say that I have been recognized as
                               a New York Times best-selling author. My writing style has
                               captivated audiences, and my stories have received widespread
                               acclaim.
                             </p>
                             <hr
                               className="my-3"
                               style={{
                                 height: "2px",
                                 backgroundColor: "#005d52",
                                 border: "none",
                                 opacity: 1,
                               }}
                             />
                             <div className="d-flex justify-content-start gap-3">
                               <Link
                                 to={
                                   "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true"
                                 }
                                 target="blank"
                               >
                                 <img
                                   src={Linkdin}
                                   alt="LinkedIn logo icon in green circle"
                                   srcset=""
                                   width={"40"}
                                   height={"40"}
                                 />
                               </Link>
               
                               <Link
                                 to={"https://www.instagram.com/junglemorals/"}
                                 target="blank"
                               >
                                 <img
                                   src={instaIcon}
                                   alt=""
                                   srcset=""
                                   width={"40"}
                                   height={"40"}
                                 />
                               </Link>
                             </div>
                           </div>
                         </div> */}
                       </section>

                <section  className="container py-1 col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`mt-3 font-brandon  ${styles.strongtextheading}`}>Similar Picks For You!</h2>
                    <div className="mt-4 mt-md-5">
                     
                        <div className={`row g-md-5 ${styles.blogRow} mt-5`}>
                            {blogPosts.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                     <div
                         className="card h-100"
                         style={{ cursor: "pointer", border: "none" }}
                         role="button"
                         tabIndex={0}
                         onClick={() => handleBlogClick(post.slug)}
                         onKeyDown={(e) => {
                           if (e.key === "Enter" || e.key === " ") handleBlogClick(post.slug);
                         }}
                       >
                            
                                        <div style={{
                                            position: 'absolute',
                                            ...animalStyles[post.animal],
                                            width: '170px',  
                                            height: '170px', 
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 10,
                                        }}>
                         
                                            <img
                                              className={`${styles.animalImg}`}
                                                src={post.animalImg}
                                                alt={post.animal}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>

                    


                    
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                       
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain', 
                                       
                                                }}
                                            />
                                        </div>

                                  
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px", 
                                            height: "30vw",       
                                            maxHeight: "100px",
                                            marginTop: "24%",  
                                            position: 'absolute',
                                            marginLeft: "61%",  

                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                                onError={(e) => {
                                                    console.log('Grass div image failed:', e);
                                                    console.log('Image path:', geassdivImg);
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 font-brandon">
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.date}</small>
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.readTime}</small>
                                            </div>
                                            <h5 className="card-title font-brandon" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px'
                                            }}>
                                                {post.title}
                                            </h5>
                                            <p className="card-text font-brandon" style={{
                                                color: '#005d52',
                                                fontSize: '14px',
                                                lineHeight: '1.5',
                                                fontWeight: '400'
                                            }}>
                                                {post.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>
                </section>



            </div>
        </>
    );
};


export default HowtoTeachKidsThatParentsKnowBest;



